//use legacy_createStore import to remove the deprecation warning
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

export default function configureStore() {
	const sagaMiddleware = createSagaMiddleware();
	const middleware = [sagaMiddleware];
	const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));
	sagaMiddleware.run(rootSaga);
	return store;
}
n